"use client";
import { useEffect, useState } from "react";
import apiClient from "../../api/apiClient";  // Import the apiClient for making API calls
import { API_ENDPOINTS } from "../../constants/apiEndpoints";  // Import API endpoints
import OrderCard from "../ordercard";  // Assuming you have this component

import "./index.css";

const OrdersWishlist = () => {
  const [activeTab] = useState("orders");
  const [orders, setOrders] = useState([]); // State to store fetched orders
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch order history when the component mounts
  useEffect(() => {

    const fetchOrders = async () => {
      try {
        // Fetch orders from the API using apiClient
        const response = await apiClient.get(API_ENDPOINTS.GET_ORDER_HISTORY, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`, // Get the token from sessionStorage
          },
        });
        setOrders(response.data.orders); // Set the fetched orders to state
        setLoading(false); // Stop loading
      } catch (err) {
        console.error("Error fetching orders:", err);
        setError("Failed to fetch orders");
        setLoading(false);
      }
    };

    fetchOrders(); // Fetch orders when the component mounts
  }, []); // Empty dependency array to only run once when the component mounts

  // Render loading state
  if (loading) {
    return <div>Loading...</div>;
  }

  // Render error state
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="ow-container">
      <div className="order-container111">

        {/* Orders Tab */}
        <h3 style={{ color: '#581c87' }}>Recent Orders</h3>
        <div className={`ow-tab-content ${activeTab === "orders" ? "ow-active" : ""}`}>

          {orders.length > 0 ? (
            orders.map((order) => {
              // Check if order has items and the first item has a mainImage
              const product = order.items[0];
              const productImage = product?.mainImage || "/placeholder.svg"; // Default image if no mainImage

              return (
                <OrderCard
                  order={order} // Pass the entire order object for more details
                  key={order.orderId} // Use orderId as the key
                  orderNumber={order.orderId}
                  status={order.orderStatus} // Assuming order has a status field
                  date={new Date(order.createdAt).toLocaleDateString()} // Format the date
                  productName={product?.name || "Product Name"} // Use the first product name as an example
                  quantity={product?.quantity || 1} // Example quantity
                  price={`${order.totalAmount.toFixed(2)}`} // Format price to two decimals
                  productImage={productImage} // Pass the product image (if available)
                />
              );
            })
          ) : (
            <p>No orders found.</p>
          )}

        </div>
      </div>
    </div>
  );
};

export default OrdersWishlist;
